var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._m(0)])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CFOP",
      "label-for": "codigo"
    }
  }, [_c('VueSelect', {
    ref: "buscarCliente",
    attrs: {
      "filterable": false,
      "options": _vm.cfops
    },
    on: {
      "search": _vm.onSearchCFOP
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao.substring(35, 0)) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.cfop,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cfop", $$v);
      },
      expression: "form.cfop"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CFOP ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição",
      "placeholder": "Venda de mercadoria"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "60",
      "state": _vm.validateState('descricao')
    },
    model: {
      value: _vm.$v.form.descricao.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.descricao, "$model", $$v);
      },
      expression: "$v.form.descricao.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tributação",
      "label-for": "tributacao"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "descricao",
      "options": _vm.tributacoes
    },
    on: {
      "search": _vm.onSearchTributacao
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tributacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tributacao", $$v);
      },
      expression: "form.tributacao"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descricao ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tributação Revenda",
      "label-for": "tributacao_revenda"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "descricao",
      "options": _vm.tributacoes
    },
    on: {
      "search": _vm.onSearchTributacao
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tributacao_revenda,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tributacao_revenda", $$v);
      },
      expression: "form.tributacao_revenda"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descricao ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "movimentaEstoque",
      "label-for": "movimentaEstoque",
      "label": "Movimenta Estoque"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.movimentaEstoque
    },
    on: {
      "change": _vm.setMovimentaEstoque
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "calculaIpi",
      "label-for": "calculaIpi",
      "label": "Calcular IPI"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": false,
      "checked": _vm.form.calculaIpi
    },
    on: {
      "change": _vm.setCalculaIPI
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "retencaoPISCOFINSCSLL",
      "label-for": "retencaoPISCOFINSCSLL",
      "label": "Rentenção PIS/COFINS/CSLL"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": false,
      "checked": _vm.form.retencaoPISCOFINSCSLL
    },
    on: {
      "change": _vm.setRetencaoPISCOFINS
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "calculaTributo",
      "label-for": "calculaTributo",
      "label": "Calcular Tributos"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.calculaTributo
    },
    on: {
      "change": _vm.setCalcularTributo
    }
  }), _c('span')])])])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "informacoesComplementares",
      "label": "Informações Complementares",
      "label-for": "informacoesComplementares"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "6",
      "max-rows": "6",
      "id": "informacoesComplementares",
      "name": "informacoesComplementares"
    },
    model: {
      value: _vm.form.informacoesComplementares,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "informacoesComplementares", $$v);
      },
      expression: "form.informacoesComplementares"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_natureza",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'naturezasLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Cadastro ")])]);
}];
export { render, staticRenderFns };